export default __webpack_public_path__ + "static/media/mobile-3.255e4e1f.png";